import { type RefObject, useEffect, useState } from "react";

/** Whether the element has come into view (or near it) once: true from then
 *  on. Without `IntersectionObserver` (a test's DOM) it is in view at once. */
export function useInView(
  ref: RefObject<Element | null>,
  rootMargin = "200px",
): boolean {
  const [seen, setSeen] = useState(
    () => typeof IntersectionObserver === "undefined",
  );
  useEffect(() => {
    const el = ref.current;
    if (seen || !el || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setSeen(true);
          io.disconnect();
        }
      },
      { rootMargin },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [ref, rootMargin, seen]);
  return seen;
}
